import * as messageBox from './ui-message-box.js'
import * as preload from './preload.js'
import * as dataTarot from './data-tarot.js'

// for _font_min
//    '00-TheFool':          '愚者',
//    '01-TheMagician':      '魔術師',
//    '02-TheHighPriestess': '女教皇',
//    '03-TheEmpress':       '女帝',
//    '04-TheEmperor':       '皇帝',
//    '05-TheHierophant':    '法王',
//    '06-TheLovers':        '恋人',
//    '07-TheChariot':       '戦車',
//    '08-Strength':         '力',
//    '09-TheHermit':        '隠者',
//    '10-WheelOfFortune':   '運命の輪',
//    '11-Justice':          '正義',
//    '12-TheHangedMan':     '吊るされた男',
//    '13-Death':            '死神',
//    '14-Temperance':       '節制',
//    '15-TheDevil':         '悪魔',
//    '16-TheTower':         '塔',
//    '17-TheStar':          '星',
//    '18-TheMoon':          '月',
//    '19-TheSun':           '太陽',
//    '20-Judgement':        '審判',
//    '21-TheWorld':         '世界',

export default async function procResult(params) {
    const { app, w, h, select } = params;
    const card = select.card;
    const elementOutput = document.querySelector('#output');
    elementOutput.innerHTML = '';
    const fontRate = 0.7

    // Show message
    const title = '今日の運勢';
    const name = dataTarot.cardsName[card.__id];
    const mes = messageBox.gen(app, `${title}\n${name}`, fontRate)
    mes.x = w * 0.5;
    mes.y = h * 0.1;
    mes.zIndex = 101;

    // Card direction
    const direction = card.__isUpright ? 'upright' : 'reverse';

    // Show output
    const pImg = preload.assets.map(x => x.src).find(x => x.includes(card.__id));
    const rotate = card.__isUpright ? '' : 'output-image-rotate';
    const subtitle = `${name}（${dataTarot.cardDirection[direction]}）`;
    const text = dataTarot.cardsText[direction][card.__id][0];
    const html = 
`<div class="output-block">
<img src="${pImg}" class="output-image ${rotate}">
<div class="output-title">${title}</div>
<div class="output-subtitle">${subtitle}</div>
<div class="output-text">　${text}</div>
</div>`;
    elementOutput.insertAdjacentHTML('beforeend', html);

    // Show message
    const mesDetail = messageBox.gen(app, `▼ 詳細`, fontRate)
    mesDetail.x = w * 0.13;
    mesDetail.y = h * 0.95;
}
